/**
 * 腾讯视频 PC 客户端
 *
 * 包含 windows 和 mac
 *
 */

// 获取 win 端云游链接
const getWinCloudGameUrl = url => `qqlive://opengame/active=1&min_width=100&min_height=100&default_width=1280&default_height=614&portalurl=${encodeURIComponent(url)}`;

// 获取 mac 端云游链接
const getMacCloudGameUrl = url => `qqlive://openportal/portalurl=${encodeURIComponent(url)}`;

// win 和 mac 通用，普通链接
const getPcNormalUrl = url => `qqlive://openportal/portalurl=${encodeURIComponent(url)}`;

// 是否为云游链接
const isCloudGameUrl = url => /^https?:\/\/gamer\.qq\.com\//.test(url);

// /^https?:\/\/(app-test\.)?iwan\.qq\.com\/game-pc\//
// /^https?:\/\/(app-test\.)?iwan\.qq\.com\/game-community\//

// 爱玩频道页链接
const iwanChannelPageReg = [
  /^https?:\/\/(app-test\.)?iwan\.qq\.com\/gamepc\//,
  /^https?:\/\/(app-test\.)?iwan\.qq\.com\/game-community\//,
];

const isIwanChannelPage = url => iwanChannelPageReg.some(pageReg => pageReg.test(url));

const tenvideoPcHandler = function ({ url, openInNewWindow }) {
  let jumpUrl = url;

  // 由 @tencent/vft-common 提供
  // isApp 腾讯视频系的app
  const { isApp, isMac, isWin } = window.magicApp?.env;

  if (!(isApp && (isMac || isWin))) return false;

  // 云游链接
  if (isCloudGameUrl(url)) {
    jumpUrl = isMac ? getMacCloudGameUrl(jumpUrl) : getWinCloudGameUrl(jumpUrl);
    location.href = jumpUrl;
    return true;
  }

  // iwan 频道页
  if (isIwanChannelPage(url)) {
    location.href = getPcNormalUrl(jumpUrl);
    return true;
  }

  if (openInNewWindow) {
    window.open(url);
    return;
  }

  // 其他普通链接，由外部处理
  return false;
};

export default tenvideoPcHandler;
